<template>
  <div id="app">
    <div id="header" class="navbar navbar-default navbar-static-top">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar"
            aria-expanded="false" aria-controls="navbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-brand" :to="{ name: 'home' }">
            <img src="../assets/img/logo-blanco.png" />
          </router-link>
        </div>
        <div id="navbar" class="navbar-collapse collapse" v-if="routesAssginedsInfo">
          <ul class="nav navbar-nav" v-if="routesAssginedsInfo !== 'public'">
            <template v-for="menuOption in menuOptions">
              <menu-option :key="menuOption.name" :menuOption="menuOption"></menu-option>
            </template>
          </ul>
          <ul class="nav navbar-nav navbar-right">
            <li v-if="$route.name === 'cat4mro.catalog.search'">
              <router-link v-if="counterInfo > 0" :to="{ name: 'cat4mro.shoppingcart' }">
                <span class="glyphicon glyphicon-shopping-cart"></span>
                <span class="label label-danger"> {{counterInfo}}</span>
              </router-link>
            </li>
            <li class="dropdown" v-if="currentUser">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                {{ currentUser.preferred_username }} <span class="caret"></span>
              </a>
              <ul class="dropdown-menu">
                <li>
                  <router-link :to="{ name: 'account' }">
                    Mi Cuenta
                  </router-link>
                </li>
                <li>
                  <router-link :to="toOrganizationRoute">
                    Mi Organización
                  </router-link>
                </li>
                <li class="divider"></li>
                <li><a href="#" @click="logout">Salir</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container" :class="layoutOptions.containerClass">
      <div class="row">
        <div class="col-xs-12">
          <breadcrumbs />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="alert alert-info m10top" role="alert" v-if="currentUserProfileInfo && currentUserProfileInfo.organization">
            <p>
              Bienvenido al Free Trail de CAT4MRO. <strong>{{ currentUserProfileInfo.fullName }}</strong> de la empresa
              <strong>{{ currentUserProfileInfo.organization.name }}</strong>
            </p>
            <p v-if="welcomeAlert" class="m10top">
              <span v-html="welcomeAlert"></span>
            </p>
          </div>
        </div>
      </div>
      <br>
      <div class="row" id="content" :class="layoutOptions.contentClass">
        <router-view />
      </div>
    </div>
    <footer id="footer" class="footer text-center">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
          <b>
            <p>© <a href="https://www.unilinkcorp.com/" target="_blank" class="ref-footer">Unilink Solutions</a></p>
          </b>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { map, filter, isNil } from 'lodash';
import MenuOption from '@/components/menu';

export default {
  components: {
    MenuOption,
  },
  data() {
    return {
      routes: [],
    };
  },
  computed: {
    ...mapGetters('shoppingCart', [
      'counterInfo',
    ]),
    ...mapGetters('auth', [
      'currentUser',
      'currentUserProfileInfo',
      'routesAssginedsInfo',
      'currentRoutesInfo',
    ]),
    menuOptions() {
      const routes = filter(this.currentRoutesInfo, route => route.meta && route.meta.menuOptions);
      const retVal = map(routes, route => ({
        name: route.name,
        path: route.path,
        title: route.meta.menuOptions.title,
        description: route.meta.menuOptions.description,
        children: map(filter(route.children, routechildren => routechildren.meta && routechildren.meta.menuOptions), routeChildren => ({
          name: routeChildren.name,
          path: routeChildren.path,
          title: routeChildren.meta.menuOptions.title,
          description: routeChildren.meta.menuOptions.description,
        })),
      }));
      return retVal;
    },
    layoutOptions() {
      return this.$route.meta.layoutOptions || { contentClass: 'content' };
    },
    welcomeAlert() {
      return this.$route.meta.welcomeAlert || '';
    },
    toOrganizationRoute() {
      if (isNil(this.currentUserProfileInfo) || isNil(this.currentUserProfileInfo.organization)) {
        return {};
      }
      return { name: 'supplier-admin.manage-organization', params: { organization: this.currentUserProfileInfo.organization.id } };
    },
  },
  mounted() {
    window.jQuery(document).ready(() => {
      function autoHeight() {
        const documentHeight = window.jQuery(document).height();
        const headerHeight = window.jQuery('#header').height();
        const footerHeight = window.jQuery('#footer').height();

        window.jQuery('#content').css('min-height', 0);
        window.jQuery('#content').css('min-height', (
          documentHeight - headerHeight - footerHeight - 50
        ));
      }

      window.jQuery(document).ready(() => {
        autoHeight();
      });

      window.jQuery(window).resize(() => {
        autoHeight();
      });
    });
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
    },
  },
};
</script>

<style>
.footer {
    position: unset !important;
}
  .v-step {
    z-index: 9999;
    background: #fff !important;
    max-width: 400px !important;
    color: #091c34 !important;
  }
  .v-step__button {
    font-size: 12px !important;
    padding: 4px !important;
    background: #c34e5d !important;
    border: .05rem solid #c34e5d !important;
    color: #fff !important;
  }
  .v-step__arrow {
    border-color: #fff !important;
  }
  .ref-footer {
    color: white !important;
}
  .footer{
    background-color: #001c34;
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
}
footer p{
  color:white;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Default.vue